import { Box, Flex, Text } from '@chakra-ui/react';
import { faTag } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, useToast } from '@morressier/alembic';
import { useDeleteTagCategory } from 'src/api/mutations';

type Props = {
  categoryId: string;
  categoryName: string;
  onClose: () => void;
  workspaceId: string;
};

const getErrorMessage = (message: unknown) => {
  if (typeof message === 'string') {
    return message;
  }

  if (
    message &&
    typeof message === 'object' &&
    'error' in message &&
    typeof message.error === 'string'
  ) {
    return message.error;
  }

  return 'Unable to delete tag category';
};

const DeleteTagCategory = ({
  categoryId,
  categoryName,
  onClose,
  workspaceId
}: Props) => {
  const deleteTagCategoryMutation = useDeleteTagCategory(workspaceId);
  const toast = useToast();

  const onDelete = async () => {
    const res = await deleteTagCategoryMutation.mutateAsync(categoryId);

    if (res.isSuccess) {
      toast({
        variant: 'success',
        title: 'Tag Category Deleted'
      });
      onClose();
      return;
    }

    toast({
      variant: 'error',
      title: getErrorMessage(res.message)
    });
  };

  return (
    <Modal
      isOpen={!!categoryId}
      onClose={onClose}
      width="450px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        flexDirection={'column'}
        gap={4}
        padding={8}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box fontSize="40px" color={'actionSecondaryCautionContent'}>
          <FontAwesomeIcon icon={faTag} fontSize="42px" />
        </Box>
        <Text textStyle="headingGroup">Delete Tag Category?</Text>
        <Text textStyle="textBody" textAlign={'center'}>
          {`"${categoryName}" will be permanently removed from this workspace if no tags are using it. Do you want to continue?`}
        </Text>
        <Flex flexDirection={'column'} gap={2} width="100%">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="caution"
            onClick={onDelete}
            isLoading={deleteTagCategoryMutation.isPending}
          >
            Delete Category
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default DeleteTagCategory;
